import { css, Theme } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const ShBlockStyle = {
  self: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    ${media.xxl} {
      padding: 0 60px;
    }
    ${media.md} {
      flex-direction: column;
      gap: 40px;
    }
  `,
  shBox: css`
    flex: 1;
    p {
      color: ${theme.colors.white};
    }
  `,

  shDescribe: css``,
  paymentBoxWrapper: css`
    flex: 1;
    display: flex;
    div {
      flex: 1;
    }
  `,
  paymentBox: ({ fontSize }: Theme) => css`
    text-align: right;
    h4 {
      font-size: ${fontSize[20]};
      text-transform: uppercase;
      font-weight: 500;
      margin-bottom: 10px;
    }
  `,
  paymentMethodImg: css`
    /*  */
  `,
  logo: css`
    height: 140px;
  `,
  description: ({ fontSize }: Theme) => css`
    width: 720px;
    font-size: ${fontSize[20]};
    line-height: 28px;
    span {
      font-weight: bold;
    }
    &[data-show="hide"] {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  `,
  btnShowMoreDesc: ({ colors, fontSize }: Theme) => css`
    color: ${colors.orange[200]} !important;
    background-color: unset !important;
    font-size: ${fontSize[20]};
    span {
      font-weight: normal !important;
    }
    cursor: pointer;
    &:hover {
      span {
        text-decoration: underline;
      }
    }
  `,
};
